// @flow

export const UPDATE_LOCATIONS = 'UPDATE_LOCATIONS';
export function updateLocations(locations: Object[]) {
  return {
    type: UPDATE_LOCATIONS,
    locations
  };
}



// WEBPACK FOOTER //
// ./src/actions/locations/basicCreators.js